/**
 * @generated SignedSource<<4a4e371d80f867a2f6959efe26779ce4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BackgroundRemoverVersion = "DEFAULT" | "LEGACY";
export type EmbeddedColorTypes = "CMYK" | "NONE" | "PANTONE";
export type ImageFormat = "AI" | "BMP" | "DXF" | "GIF" | "JPEG" | "PDF" | "PNG" | "SVG";
export type ImageInsertScalingType = "AUTOFIT_SCALE_TO_COVER" | "AUTOFIT_SCALE_TO_FIT" | "SCALE_DOWN";
export type OutputMirrorPrintFiles = "BOTH" | "MIRROR_HORIZONTALLY" | "MIRROR_VERTICALLY" | "NONE";
export type PrintTypeOutputType = "FILE_PER_AREA" | "FILE_PER_COLOR";
export type VectorizeOptionTypeEnum = "NONE" | "RASTER";
export type PrintTypeUpdateInput = {
  backgroundRemoverSettings?: NullableValueInputOfPrintTypeBackgroundRemoverSettingInput | null;
  colorProfileFileUrl?: NullableValueInputOfStringInput | null;
  defaultFontFamilyID?: ValueInputOfNullableOfInt64Input | null;
  dpi?: ValueInputOfInt32Input | null;
  fonts?: NullableValueInputOfListOfInt64Input | null;
  id: string;
  layeredPdf?: ValueInputOfBooleanInput | null;
  maxColors?: ValueInputOfNullableOfInt32Input | null;
  name?: ValueInputOfStringInput | null;
  outputDesignEffect?: NullableValueInputOfDesignEffectInput | null;
  outputFileFormats?: NullableValueInputOfListOfImageFormatInput | null;
  outputMirror?: ValueInputOfNullableOfOutputMirrorPrintFilesInput | null;
  outputSettings?: NullableValueInputOfPrintTypeOutputSettingsInput | null;
  outputType?: ValueInputOfPrintTypeOutputTypeInput | null;
  paletteID?: NullableValueInputOfStringInput | null;
  pantoneEnabled?: ValueInputOfBooleanInput | null;
  patternSetting?: NullableValueInputOfPrintTypePatternSettingInput | null;
  previewDesignEffect?: NullableValueInputOfDesignEffectInput | null;
  providerCode?: NullableValueInputOfStringInput | null;
  restrictions?: NullableValueInputOfPrintTypeRestrictionInput | null;
  rgbConversionListID?: NullableValueInputOfStringInput | null;
  splitColorFiles?: ValueInputOfBooleanInput | null;
};
export type ValueInputOfStringInput = {
  value?: string | null;
};
export type NullableValueInputOfStringInput = {
  value?: string | null;
};
export type ValueInputOfInt32Input = {
  value: number;
};
export type ValueInputOfPrintTypeOutputTypeInput = {
  value: PrintTypeOutputType;
};
export type NullableValueInputOfListOfInt64Input = {
  value?: ReadonlyArray<number> | null;
};
export type ValueInputOfNullableOfInt64Input = {
  value?: number | null;
};
export type NullableValueInputOfListOfImageFormatInput = {
  value?: ReadonlyArray<ImageFormat> | null;
};
export type ValueInputOfBooleanInput = {
  value: boolean;
};
export type NullableValueInputOfPrintTypeRestrictionInput = {
  value?: PrintTypeRestrictionInput | null;
};
export type PrintTypeRestrictionInput = {
  allowAdaptText?: ValueInputOfBooleanInput | null;
  allowBold?: ValueInputOfBooleanInput | null;
  allowBottomVerticalAlignment?: ValueInputOfBooleanInput | null;
  allowCenterAlign?: ValueInputOfBooleanInput | null;
  allowChangeFontSize?: ValueInputOfBooleanInput | null;
  allowGradientTextColors?: ValueInputOfBooleanInput | null;
  allowImageGalleryTextColors?: ValueInputOfBooleanInput | null;
  allowImageResizeCliparts?: ValueInputOfBooleanInput | null;
  allowImageResizeUpload?: ValueInputOfBooleanInput | null;
  allowImageUploadTextColors?: ValueInputOfBooleanInput | null;
  allowItalic?: ValueInputOfBooleanInput | null;
  allowJustifyAlign?: ValueInputOfBooleanInput | null;
  allowLeftAlign?: ValueInputOfBooleanInput | null;
  allowLetterSpacing?: ValueInputOfBooleanInput | null;
  allowLineSpacing?: ValueInputOfBooleanInput | null;
  allowMiddleVerticalAlignment?: ValueInputOfBooleanInput | null;
  allowRightAlign?: ValueInputOfBooleanInput | null;
  allowShadows?: ValueInputOfBooleanInput | null;
  allowTextStroke?: ValueInputOfBooleanInput | null;
  allowTopVerticalAlignment?: ValueInputOfBooleanInput | null;
  canAddText?: ValueInputOfBooleanInput | null;
  canChangeSvgColors?: ValueInputOfBooleanInput | null;
  canIgnoreDPIWarning?: ValueInputOfBooleanInput | null;
  canPrintShadows?: ValueInputOfBooleanInput | null;
  canStretchImages?: ValueInputOfBooleanInput | null;
  canStretchTexts?: ValueInputOfBooleanInput | null;
  canUseImageFilters?: ValueInputOfBooleanInput | null;
  canUseTextArt?: ValueInputOfBooleanInput | null;
  convertAiToSvg?: ValueInputOfBooleanInput | null;
  convertEpsToSvg?: ValueInputOfBooleanInput | null;
  convertPdfToSvg?: ValueInputOfBooleanInput | null;
  createVectorizePreview?: ValueInputOfBooleanInput | null;
  curvedText?: ValueInputOfBooleanInput | null;
  defaultColor?: NullableValueInputOfStringInput | null;
  defaultFontSize?: ValueInputOfNullableOfInt32Input | null;
  defaultShadowAngle?: ValueInputOfNullableOfInt32Input | null;
  defaultShadowBlur?: ValueInputOfNullableOfInt32Input | null;
  defaultShadowColor?: NullableValueInputOfStringInput | null;
  defaultShadowDistance?: ValueInputOfNullableOfInt32Input | null;
  disableImageColors?: ValueInputOfBooleanInput | null;
  disableImageRotateCliparts?: ValueInputOfBooleanInput | null;
  disableImageRotateUpload?: ValueInputOfBooleanInput | null;
  disableSellerImages?: ValueInputOfBooleanInput | null;
  disableTextColors?: ValueInputOfBooleanInput | null;
  disableUserImages?: ValueInputOfBooleanInput | null;
  embeddedColorType?: ValueInputOfEmbeddedColorTypesInput | null;
  embeddedPdf?: ValueInputOfBooleanInput | null;
  embeddedUseForRasterAlso?: ValueInputOfBooleanInput | null;
  enableVectorize?: ValueInputOfBooleanInput | null;
  fixedFontSize?: ValueInputOfNullableOfInt32Input | null;
  fontSizeList?: NullableValueInputOfListOfInt64Input | null;
  imageColors?: NullableValueInputOfPrintTypeRestrictionColorInput__Input | null;
  imageEditingToolSettingsToExclude?: NullableValueInputOfStringInput | null;
  imageInsertScalingCliparts?: ValueInputOfImageInsertScalingTypeInput | null;
  imageInsertScalingUpload?: ValueInputOfImageInsertScalingTypeInput | null;
  isLargeFileEnabled?: ValueInputOfBooleanInput | null;
  maxFontSize?: ValueInputOfNullableOfInt32Input | null;
  maxHeightImageResizeCliparts?: ValueInputOfNullableOfInt32Input | null;
  maxHeightImageResizeUpload?: ValueInputOfNullableOfInt32Input | null;
  maxLetterSpacing?: ValueInputOfNullableOfInt32Input | null;
  maxLineSpacing?: ValueInputOfNullableOfInt32Input | null;
  maxNrImages?: ValueInputOfNullableOfInt32Input | null;
  maxNrTextElements?: ValueInputOfNullableOfInt32Input | null;
  maxShadowAngle?: ValueInputOfNullableOfInt32Input | null;
  maxShadowBlur?: ValueInputOfNullableOfInt32Input | null;
  maxShadowDistance?: ValueInputOfNullableOfInt32Input | null;
  maxTextStrokeWidth?: ValueInputOfNullableOfInt32Input | null;
  maxWidthImageResizeCliparts?: ValueInputOfNullableOfInt32Input | null;
  maxWidthImageResizeUpload?: ValueInputOfNullableOfInt32Input | null;
  minFontSize?: ValueInputOfNullableOfInt32Input | null;
  minHeightImageResizeCliparts?: ValueInputOfNullableOfInt32Input | null;
  minHeightImageResizeUpload?: ValueInputOfNullableOfInt32Input | null;
  minLetterSpacing?: ValueInputOfNullableOfInt32Input | null;
  minLineSpacing?: ValueInputOfNullableOfInt32Input | null;
  minShadowAngle?: ValueInputOfNullableOfInt32Input | null;
  minShadowBlur?: ValueInputOfNullableOfInt32Input | null;
  minShadowDistance?: ValueInputOfNullableOfInt32Input | null;
  minTextStrokeWidth?: ValueInputOfNullableOfInt32Input | null;
  minWidthImageResizeCliparts?: ValueInputOfNullableOfInt32Input | null;
  minWidthImageResizeUpload?: ValueInputOfNullableOfInt32Input | null;
  outputMirror?: ValueInputOfNullableOfOutputMirrorPrintFilesInput | null;
  shadowColors?: NullableValueInputOfPrintTypeRestrictionColorInput__Input | null;
  showImageProvider?: ValueInputOfBooleanInput | null;
  showVectorizeModal?: ValueInputOfBooleanInput | null;
  textBox?: ValueInputOfBooleanInput | null;
  textColors?: NullableValueInputOfPrintTypeRestrictionColorInput__Input | null;
  uploadRestrictions?: NullableValueInputOfPrintTypeUploadRestrictionsInput | null;
  uppercase?: ValueInputOfBooleanInput | null;
  useImagesFixedSize?: ValueInputOfBooleanInput | null;
  vectorizeOption?: ValueInputOfVectorizeOptionTypeEnumInput | null;
};
export type ValueInputOfVectorizeOptionTypeEnumInput = {
  value: VectorizeOptionTypeEnum;
};
export type NullableValueInputOfPrintTypeRestrictionColorInput__Input = {
  value?: ReadonlyArray<PrintTypeRestrictionColorInput | null> | null;
};
export type PrintTypeRestrictionColorInput = {
  colorCode: string;
  isDefault: boolean;
};
export type NullableValueInputOfPrintTypeUploadRestrictionsInput = {
  value?: PrintTypeUploadRestrictionsInput | null;
};
export type PrintTypeUploadRestrictionsInput = {
  isAiAllowed: boolean;
  isEpsAllowed: boolean;
  isFacebookAllowed: boolean;
  isInstagramAllowed: boolean;
  isJpgAllowed: boolean;
  isPdfAllowed: boolean;
  isPdfWithRasterAllowed: boolean;
  isPngAllowed: boolean;
  isSvgAllowed: boolean;
  isUserImageAllowed: boolean;
  resizeLargePdf: boolean;
};
export type ValueInputOfImageInsertScalingTypeInput = {
  value: ImageInsertScalingType;
};
export type ValueInputOfNullableOfInt32Input = {
  value?: number | null;
};
export type ValueInputOfEmbeddedColorTypesInput = {
  value: EmbeddedColorTypes;
};
export type ValueInputOfNullableOfOutputMirrorPrintFilesInput = {
  value?: OutputMirrorPrintFiles | null;
};
export type NullableValueInputOfPrintTypeOutputSettingsInput = {
  value?: PrintTypeOutputSettingsInput | null;
};
export type PrintTypeOutputSettingsInput = {
  columns?: ValueInputOfInt32Input | null;
  flowDirectionH?: ValueInputOfInt32Input | null;
  flowDirectionPriority?: ValueInputOfInt32Input | null;
  flowDirectionV?: ValueInputOfInt32Input | null;
  height?: ValueInputOfDecimalInput | null;
  marginH?: ValueInputOfDecimalInput | null;
  marginV?: ValueInputOfDecimalInput | null;
  rotation?: ValueInputOfDecimalInput | null;
  rows?: ValueInputOfInt32Input | null;
  width?: ValueInputOfDecimalInput | null;
};
export type ValueInputOfDecimalInput = {
  value: number;
};
export type NullableValueInputOfDesignEffectInput = {
  value?: DesignEffectInput | null;
};
export type DesignEffectInput = {
  blendMode?: ValueInputOfStringInput | null;
  enhanceBlendMode?: ValueInputOfBooleanInput | null;
  imageEffectParameterValues?: NullableValueInputOfListOfImageEffectParameterValueInput | null;
  imageEffectTypeName?: ValueInputOfStringInput | null;
  opacity?: ValueInputOfSingleInput | null;
  textColor?: NullableValueInputOfStringInput | null;
  type?: ValueInputOfInt32Input | null;
};
export type ValueInputOfSingleInput = {
  value: number;
};
export type NullableValueInputOfListOfImageEffectParameterValueInput = {
  value?: ReadonlyArray<ImageEffectParameterValueInput | null> | null;
};
export type ImageEffectParameterValueInput = {
  name: string;
  value: string;
};
export type NullableValueInputOfPrintTypeBackgroundRemoverSettingInput = {
  value?: PrintTypeBackgroundRemoverSettingInput | null;
};
export type PrintTypeBackgroundRemoverSettingInput = {
  isEditEnabled?: ValueInputOfBooleanInput | null;
  isHiddenMode?: ValueInputOfBooleanInput | null;
  isUploadEnabled?: ValueInputOfBooleanInput | null;
  removerVersion?: ValueInputOfBackgroundRemoverVersionInput | null;
};
export type ValueInputOfBackgroundRemoverVersionInput = {
  value: BackgroundRemoverVersion;
};
export type NullableValueInputOfPrintTypePatternSettingInput = {
  value?: PrintTypePatternSettingInput | null;
};
export type PrintTypePatternSettingInput = {
  allowOffsetChange?: ValueInputOfBooleanInput | null;
  allowSpacingChange?: ValueInputOfBooleanInput | null;
  isImageEnabled?: ValueInputOfBooleanInput | null;
  isTextEnabled?: ValueInputOfBooleanInput | null;
  presets?: NullableValueInputOfInt64__Input | null;
};
export type NullableValueInputOfInt64__Input = {
  value?: ReadonlyArray<number> | null;
};
export type printingMethodEditor_UpdatePrintTypeMutation$variables = {
  input: PrintTypeUpdateInput;
};
export type printingMethodEditor_UpdatePrintTypeMutation$data = {
  readonly updatePrintType: {
    readonly printType: {
      readonly id: string;
    } | null;
  };
};
export type printingMethodEditor_UpdatePrintTypeMutation = {
  response: printingMethodEditor_UpdatePrintTypeMutation$data;
  variables: printingMethodEditor_UpdatePrintTypeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PrintTypeOutput",
    "kind": "LinkedField",
    "name": "updatePrintType",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PrintType",
        "kind": "LinkedField",
        "name": "printType",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "printingMethodEditor_UpdatePrintTypeMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "printingMethodEditor_UpdatePrintTypeMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "db1cd744ed0a8f479ec38b380853ff82",
    "id": null,
    "metadata": {},
    "name": "printingMethodEditor_UpdatePrintTypeMutation",
    "operationKind": "mutation",
    "text": "mutation printingMethodEditor_UpdatePrintTypeMutation(\n  $input: PrintTypeUpdateInput!\n) {\n  updatePrintType(input: $input) {\n    printType {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b91a796247ebd859b02defc4618b663";

export default node;
